const state = {
    myDataSelectedReport: null,
  };
  
  const mutations = {
    SET_MY_DATA_SELECTED_REPORT: (state, myDataSelectedReport) => {
        state.myDataSelectedReport = myDataSelectedReport;
      }
   
  };
  
  const getters = {
    myDataSelectedReport: (state) => state.myDataSelectedReport,
  };
  
  const selectedReportModule = {
    state,
    getters,
    mutations,
  };
  
  export default selectedReportModule;